export const isDev = (env) => env === 'development';
